import {
  CLEAR_PUBLIC_SHARED_LINK,
  CREATE_SHAREDLINK,
  GET_SHAREDLINK,
  GET_SHAREDLINK_END,
  GET_SHAREDLINK_START,
  PublicSharedLinkActionTypes,
  PublicSharedLinkState,
} from '../types/publicSharedLinkTypes';

const INITIAL_STATE: PublicSharedLinkState = {
  fetchingSharedLink: false,
  sharedLink: null,
};

export default (state = INITIAL_STATE, action: PublicSharedLinkActionTypes) => {
  switch (action.type) {
    case GET_SHAREDLINK_START:
      return {
        ...state,
        fetchingSharedLink: true,
      };
    case GET_SHAREDLINK_END:
      return {
        ...state,
        fetchingSharedLink: false,
      };
    case GET_SHAREDLINK:
      return {
        ...state,
        sharedLink: action.payload,
      };
    case CREATE_SHAREDLINK:
      return {
        ...state,
        sharedLink: action.payload,
      };
    case CLEAR_PUBLIC_SHARED_LINK:
      return {
        ...state,
        sharedLink: null,
      };
    default:
      return state;
  }
};
